import {vector} from "./Vector";

export const getDisplacements = (objects, forces, dt) => {
    return objects.map((object, index) => {
        let forceVector = vector.get();
        forces.forEach(force => {
            switch (force.type) {
                case "external":
                    forceVector = vector.add(forceVector, force.external(object));
                    break;
                case "interaction":
                    objects.forEach((other, otherIndex) => {
                        if (otherIndex === index) return;
                        forceVector = vector.add(forceVector, force.interaction(other, object));
                    });
                    break;
                default:
                    break;
            }
        });
        let displacement = {
            r: vector.multiply(object.v, dt),
            v: vector.multiply(forceVector, dt / object.m)
        };
        forces.filter(force => force.type === "reflection").forEach(force => {
            displacement = force.reflection(object, displacement);
        });
        return displacement;
    });
}
